<button class="see-more-btn" [class.shadow]="!expanded" (click)="handleClick()">
  <span>{{ readMoreTogglerText }}</span
  ><fa-icon [icon]="expanded ? faCaretUp : faCaretDown"></fa-icon>
</button>
